import React, { useState, FunctionComponent, SyntheticEvent } from 'react'
import cn from 'classnames'
import Loader from 'react-loader-spinner'
import { TFunction } from 'next-i18next'
import { Input } from '~/components'

interface Props {
  onSubmit: (username: string, password: string) => void
  loading?: boolean
  error?: string
  t: TFunction
}

const LoginForm: FunctionComponent<Props> = ({
  loading = false,
  error = '',
  onSubmit,
  needEmail = false,
  needNewPass = false,
  t,
}: Props) => {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [email, setEmail] = useState('')
  const [newPassword, setNewPassword] = useState('')

  const handleSubmit = (e: SyntheticEvent) => {
    e.preventDefault()
    onSubmit(username, password, email, newPassword, needNewPass)
  }

  const secondStage = needEmail || needNewPass;

  return (
    <form onSubmit={handleSubmit}>
      {!secondStage && <div className="mb-4 relative">
        <Input
          id="username"
          inputType="text"
          label={t('Username')}
          labelClasses={cn({
            filled: username !== '',
          })}
          onChange={e => {
            setUsername(e.target.value)
          }}
          required
          value={username}
        />
      </div>}
      {!secondStage && <div className="mb-4 relative">
        <Input
          id="password"
          inputType="password"
          label={t('Password')}
          labelClasses={cn({
            filled: password !== '',
          })}
          onChange={e => {
            setPassword(e.target.value)
          }}
          required
          value={password}
        />
      </div>}
      {needEmail && <div className="mb-4 relative">
        <Input
          id="email"
          inputType="email"
          label={t('Email')}
          labelClasses={cn({
            filled: email !== '',
          })}
          onChange={e => {
            setEmail(e.target.value)
          }}
          required
          value={email}
        />
      </div>}
      {needNewPass && <div className="mb-4 relative">
        <Input
          id="newPassword"
          inputType="password"
          label={t('New password')}
          labelClasses={cn({
            filled: newPassword !== '',
          })}
          onChange={e => {
            setNewPassword(e.target.value)
          }}
          required
          value={newPassword}
        />
      </div>}
      {!!error && (
        <div
          className="text-red-700 pt-2 pb-6 rounded relative"
          role="alert"
          data-cy="login-error"
        >
          {error}
        </div>
      )}
      <button
        className="bg-brand-600 hover:bg-brand-500 text-white font-bold py-3 px-6 rounded w-full flex justify-center items-center h-12"
        type="submit"
      >
        {loading ? (
          <Loader type="ThreeDots" color="#FFF" height={10} width={100} />
        ) : (
          t('Login')
        )}
      </button>
    </form>
  )
}

export default LoginForm
